import { omitBy } from 'lodash-es';
import type { Types } from '../../types';
import type { ConnectedTypes } from '../../make-connected';
import { parseMaxWorkingHours } from './util/parse-max-working-hours';
import { parseDayIndices } from './util/parse-days';
import { idOf } from './util/util';
import { getDefaultInterval } from './intervals';

export function fromTeachers (
  teachers: ConnectedTypes.teacher[],
  settings: ConnectedTypes.divisionSettings,
  options:  Types.parsedToOptions
): Types.Entities.Group[] {
  const defaultInterval = getDefaultInterval(settings);

  return teachers
    .map(teacher => {
      const intervals    = teacher.intervals    ?? defaultInterval;
      const rootInterval = teacher.rootInterval ?? settings.defaultRootInterval;

      const doc: Types.Entities.Group = {
        id:                            idOf.teacher(teacher, options),
        group_type:                    'personal',
        minimizeGaps:                  settings.minimizeTeacherGaps,
        minimizeDependencyAlternation: true,
        weight:                        teacher.weight,
        intervals:                     idOf.intervalPairReference(intervals, rootInterval, options),
        days:                          parseDayIndices(teacher.days, settings),
        blockedTimes:                  teacher.lockedTimes?.map(x => idOf.lockedTime(x, options)),
        minBreakDuration:              teacher.minBreakLength,
        ...parseMaxWorkingHours(teacher),
      };

      if (options.includeEntityMeta) {
        doc.name = teacher.displayName;
      }

      return omitBy(doc, x => x == null) as Types.Entities.Group;
    });
};
